import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import NoVolumeCalculationsImage from '../../../../../../../static/no_volume_calculations.svg?react';
import { IconPanel } from '../../../../icon-panel/icon-panel';
import { RightPanelContent } from '../../../../skyview/right-menu/components/styles';

export const NoVolumesPanel = () => {
  const { t } = useTranslation();
  return (
    <RightPanelContent useTopPadding={false}>
      <IconPanel header={<NoVolumeCalculationsImage />} responsiveness={{ compressed: false }}>
        {{
          title: t('title', { ns: 'skyviewReport' }),
          info: (
            <Trans components={{ br: <br /> }} i18nKey="noVolumeCalculations" ns="skyviewReport" />
          ),
        }}
      </IconPanel>
    </RightPanelContent>
  );
};
